import { Text, Avatar } from 'components';
import React from 'react';
import styled from 'styled-components';
import { OrgAddress } from '@bb/automaton';
import { IMLSNumbers } from '@bb/users';
import type { JsonObject } from '@/app-package';
import { featureEnabled } from 'utils';
import { SupraCoopType } from '@bb/domain/dist/types';
import SupraCoopTypeTag from '../MLSStaffPages/Tags/CoopTypeTag';

type Label = JsonObject<{
  name: string;
  firstName: string;
  lastName: string;
  logo: string;
  type: string;
  mlsNumbers: IMLSNumbers[];
  branchName: string;
  address: OrgAddress;
  oid?: string;
  coopType?: SupraCoopType;
}>;

const SearchLabel = (label: Label, isMlsUser: boolean) => {
  if (!label) return <></>;

  const {
    name,
    firstName,
    lastName,
    logo,
    type,
    mlsNumbers,
    branchName,
    address,
    oid,
    coopType,
  }: Label = label;

  const props: any = {};
  if (type === 'user') {
    props.user = {
      firstName,
      lastName,
      avatarFilestackId: logo,
      mlsNumbers,
      branchName,
    };
    if (logo) {
      props.backgroundColor = 'background';
    }
  } else {
    props.user = { firstName: name };

    if (logo) {
      props.src = logo;
      props.backgroundColor = 'background';
    }
  }
  return (
    <>
      <FlexContainer>
        <Avatar {...props} />
        <NameContainer>
          <Text style={{ marginLeft: '5px' }} ellipsis block>
            {featureEnabled('improvedLockboxAssignmentFeature') &&
            type === 'office'
              ? branchName
              : name}
          </Text>
          {mlsNumbers && mlsNumbers.length && (
            <StyledType>{`ID#${mlsNumbers[0].number}`}</StyledType>
          )}
          {oid &&
            (featureEnabled('improvedLockboxAssignmentFeature')
              ? type === 'office'
              : type === 'branch') && <StyledType>{`ID#${oid}`}</StyledType>}
          {featureEnabled('supraAutoCoopFeature') &&
            coopType &&
            coopType !== SupraCoopType.PRIMARY && (
              <StyledTag>
                <SupraCoopTypeTag coopType={coopType} />
              </StyledTag>
            )}
        </NameContainer>
      </FlexContainer>
      {isMlsUser &&
      (featureEnabled('improvedLockboxAssignmentFeature')
        ? type === 'office'
        : type === 'branch') &&
      address ? (
        <AdditionalInfoContainer>
          <StyledType>{address.line1}</StyledType>
        </AdditionalInfoContainer>
      ) : null}
      {type === 'user' && branchName ? (
        <AdditionalInfoContainer>
          <StyledType>{branchName}</StyledType>
        </AdditionalInfoContainer>
      ) : null}
    </>
  );
};

const StyledType = styled(Text)`
  margin-left: 5px;
  font-weight: 400;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 85%;
`;

const AdditionalInfoContainer = styled.div`
  padding-left: 32px;
`;

const StyledTag = styled.div`
  margin-left: auto;
`;

export default SearchLabel;
